import { ColourSchemas, ColourSchemaValue } from 'models/colourSchema';

const getColourPropsByColourSchemaAndCampaignColor = (
  color: string,
  colourSchema?: ColourSchemaValue,
) => {
  if (!colourSchema) {
    return {
      backgroundColor: color,
      headingColor: 'var(--danger)',
      textColorClass: 'text-white',
      btnVariant: 'danger',
    };
  }
  return colourSchema === ColourSchemas.secondary
    ? {
        backgroundColor: `var(--${ColourSchemas.secondary})`,
        headingColor: 'var(--danger)',
        textColorClass: undefined,
        btnVariant: 'danger',
      }
    : {
        backgroundColor: `var(--${colourSchema})`,
        headingColor: 'var(--secondary)',
        textColorClass: 'text-white',
        btnVariant: 'danger',
      };
};

export default getColourPropsByColourSchemaAndCampaignColor;
